import SerialNumberFirstScanPopUp from "./serialNumberFirstScanPopup.container";

export default SerialNumberFirstScanPopUp;
